<template>
    <div v-lazy-container="{ selector: 'img' }" :class="`${roundedPlaceholderClass}`">
        <img
            :data-src="resolvedImageUrl"
            :data-loading="resolvedPlaceholderUrl"
            :width="width"
            :height="height"
            :class="imageClass"
            :alt="alt"
        />
    </div>
</template>

<script>
    import { resolveAssetUrl } from "@/util/url"

    export default {
        props: {
            imageUrl: {
                type: String,
            },
            placeholderUrl: {
                type: String,
            },
            alt: {
                type: String,
            },
            width: {
                type: String,
            },
            height: {
                type: String,
            },
            imageClass: {
                type: String,
            },
        },

        computed: {
            resolvedImageUrl() {
                return resolveAssetUrl(this.imageUrl)
            },

            resolvedPlaceholderUrl() {
                return resolveAssetUrl(this.placeholderUrl)
            },

            roundedPlaceholderClass() {
                return this.rounded ? "image-placeholder--rounded" : ""
            },
        },
    }
</script>

<style lang="scss" scoped>
    .image-placeholder {
        overflow: hidden;
        line-height: 0;

        &--rounded {
            border-radius: 100%;
        }
    }

    img {
        transition: all ease 0.3s;
        opacity: 0;

        &[lazy="loading"] {
            opacity: 1;
            filter: blur(15px);
        }

        &[lazy="loaded"] {
            opacity: 0.99;
        }
    }
</style>
